const DataTableStyleEnum=
{
    Simple:'Simple',
    ComplexWithoutTranslation:'ComplexWithoutTranslation',
    Complex:'DelComplexete',
};

export default DataTableStyleEnum;